import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
const HeroSection = () => {
  const navigate = useNavigate();
  const handleJoinWaitlist = () => {
    navigate('/join-waitlist');
  };
  return <section className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#E0F2FE] via-[#DBEAFE] to-[#C7D2FE] -z-10" />
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center gap-8">
        <div className="w-full md:w-1/2 text-left">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-black font-sans tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-[#0EA5E9] to-[#6366F1]">Talento AI</h1>
          <p className="text-xl md:text-2xl mb-12 text-gray-800 max-w-2xl font-light leading-relaxed">Human + AI</p>
          <Button onClick={handleJoinWaitlist} size="lg" className="bg-gradient-to-r from-[#0EA5E9] to-[#3B82F6] text-white hover:opacity-90 text-lg px-8 py-6 h-auto shadow-lg transition-all duration-300 hover:translate-y-[-2px]">Join Waitlist </Button>
        </div>
        <div className="w-full md:w-1/2">
          <img src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=800&q=80" alt="Human and AI working together" className="rounded-lg shadow-2xl" />
        </div>
      </div>
    </section>;
};
export default HeroSection;